export const ACCESS_DENIED = 'auth/ACCESS_DENIED';
export const AUTH_BASE = 'auth/AUTH_BASE';
export const AUTHENTICATING = 'auth/AUTHENTICATING';
export const AUTH_SUCCESS = 'auth/AUTH_SUCCESS';
export const AUTH_ERROR = 'auth/AUTH_ERROR';
export const AUTH_COMPLETE = 'auth/AUTH_COMPLETE';
export const SET_API_TOKEN = 'auth/SET_API_TOKEN';
export const SIGN_OUT = 'auth/SIGN_OUT';
